// extracted by mini-css-extract-plugin
export default {"button":"NewModal_button__PG9N6","divider":"NewModal_divider__2tFS+","link":"NewModal_link__sN6ZT","input":"NewModal_input__D9q4P"};